import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseInfo from '@blade-sxp/device-management-pass/components/detail/list-detail.vue';
import PassInfo from '@blade-sxp/device-management-pass/components/detail/pass-info.vue';
import SonInfo from '@blade-sxp/device-management-pass/components/detail/son-info.vue';
import LibraryDistributed from '@blade-sxp/device-management-pass/components/detail/library-distributed.vue';
import AddDistributed from '@blade-sxp/device-management-pass/components/detail/add-distributed.vue';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import { dbsyncAdd, dbsyncList } from '@blade-sxp/device-management-pass/api/dbSync';
import { cloneDeep } from 'lodash';
const Webapi = {
    dbsyncAdd,
    dbsyncList,
};
let default_1 = class default_1 extends Vue {
    tableData = [];
    queryForm = {
        libName: '',
    };
    paginationParams = {
        page: 1,
        size: 10,
        total: 0,
        deviceId: '',
    };
    lastPaginationParams = null;
    addVisible = false;
    loading = false;
    paginationParamsChange() {
        // 加载策略 页码和页面尺寸发生变化时重新加载列表
        if (!this.lastPaginationParams)
            return this.getList();
        let curr = this.paginationParams;
        let last = this.lastPaginationParams;
        if (curr.page !== last.page || curr.size !== last.size)
            this.getList();
    }
    created() {
        this.$router.onReady(async () => {
            const query = this.$route.query;
            this.paginationParams.deviceId = query.deviceId.toString();
            this.getList();
        });
    }
    handleAdd() {
        this.addVisible = true;
    }
    // 获取数据
    async getList() {
        if (!this.paginationParams)
            return;
        this.loading = true;
        try {
            let result = await Webapi.dbsyncList({
                ...this.paginationParams,
                libName: this.queryForm.libName,
                orderBy: '',
            });
            this.paginationParams.total = result.total;
            this.tableData = result.list;
            this.lastPaginationParams = cloneDeep(this.paginationParams);
        }
        catch (error) {
            console.log('Webapi.dbsyncList error', error);
        }
        this.loading = false;
    }
    // 刷新列表
    refreshList() {
        if (!this.paginationParams)
            return;
        this.tableData = [];
        if (this.paginationParams.page !== 1)
            this.paginationParams.page = 1;
        else
            this.getList();
    }
};
__decorate([
    Watch('paginationParams', { deep: true })
], default_1.prototype, "paginationParamsChange", null);
default_1 = __decorate([
    Component({
        components: { BaseInfo, PassInfo, SonInfo, LibraryDistributed, InputSearch, AddDistributed },
        i18n: {
            messages: {
                'en-us': {
                    bgdManagement: 'Background Management',
                    portraitLibraryDistributed: 'Portrait Library Distributed',
                    portraitLibraryName: 'Portrait Library Name',
                    add: 'Add',
                },
                zh: {
                    bgdManagement: '背景图管理',
                    portraitLibraryDistributed: '人像库下发',
                    portraitLibraryName: '人像库名称',
                    add: '添加',
                },
            },
        },
    })
], default_1);
export default default_1;
